import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CallToAction.module.css';
import Button from '../UI/Button';

const CallToAction = () => {
    return (
        <section className={styles.cta}>
            <div className={styles.container}>
                <div className={styles.ctaContent}>
                    <h2 className={styles.ctaTitle}>
                        Ready to Transform Your Business?
                    </h2>
                    <p className={styles.ctaDescription}>
                        Let's discuss your project and create something amazing together. 
                        Get in touch with us today for a free consultation.
                    </p>
                    <div className={styles.ctaButtons}>
                        <Button
                        as={Link}
                        to="/contact"
                        variant="primary"
                        size="large"
                        className={styles.ctaButton}
                        >
                        Get Started
                        </Button>
                        <Button
                        as={Link}
                        to="/services"
                        variant="secondary"
                        size="large"
                        className={styles.ctaButton}
                        >
                        Learn More
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CallToAction;